import React  from "react";
import { withRouter } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";

const GoBack = ({ history }) => {
  return (
      <IconButton style={{paddingLeft:0, marginTop:10, marginBottom:10}}
      onClick={() => history.goBack()}>
        <ArrowBack fontSize="small" />
        <span style={{fontSize:'1rem', color: "#000000de"}}>Voltar</span>
      </IconButton>
  );
};

export default withRouter(GoBack);
